/**
 * Does an appliance claim a corner? ONE predicate for the three places that ask:
 *
 *   - the scorer — `scoring/counterSpace.js` takes the perpendicular wall's
 *     counter away at a claimed corner;
 *   - the generator's corner classifier — `cornerDetection.analyzeWallAt`
 *     turns a claim into `appliance-on-*`, reserving depth + 30" on that wall;
 *   - the run engine — `cabinet-runs/cornerTreatment.applianceEndsRunAt`
 *     ends the run at the vertex instead of turning it.
 *
 * They must agree: a layout scored for counter it never gets ranks wrong, and
 * an engine that joins a run the generator ended changes the cabinets on the
 * first edit.
 *
 * An appliance claims the corner when its body comes nearer the vertex than one
 * cabinet depth — that strip is where the other leg's cabinets stand. One
 * seated EXACTLY a depth out touches the strip's edge and reaches none of it, so
 * it does not claim the corner.
 *
 * That boundary is the common case, not an edge case: slot enumeration seats
 * appliances flush against the 24" corner reservation, and
 * `slots/extractCorners.js` puts every 30" appliance in a corner-offset slot
 * exactly 24" from the wall end. A bare `gap < depth` answered on the last bit
 * of a double (0.6095999999999995 < 0.6096), so which walls claimed a corner
 * was effectively random, and swapping `Math.hypot` for `hypot2` in
 * `getWallAxes` re-rolled it. `TOUCH_EPS` absorbs that; any overlap a real
 * placement could have is far larger.
 */

const { KITCHEN_CABINET_DIMENSIONS } = require('./constants');

const CORNER_PROXIMITY = KITCHEN_CABINET_DIMENSIONS.depth; // 24"
const TOUCH_EPS = 1e-4;

/** @param {number} gap - along-run distance (m) from the appliance body to the vertex. */
function claimsCorner(gap) {
  return gap < CORNER_PROXIMITY - TOUCH_EPS;
}

module.exports = { CORNER_PROXIMITY, claimsCorner };
